import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import api from '~/services/api';
import { isNullOrEmpty } from '~/helpers/util';

import { projectDashboardSuccess, projectDashboardFailure } from './actions';

export function* onIndex({ payload }) {
  try {
    const { projectId, sprintId } = payload;

    const params = isNullOrEmpty(sprintId) ? '' : `?sprintId=${sprintId}`;

    const response = yield call(api.get, `projects/${projectId}/dashboard${params}`);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Falha ao obter os dados do dashboard do projeto';

    yield put(projectDashboardSuccess(result.data));
  }
  catch (err) {
    toast.error(String(err));
    yield put(projectDashboardFailure());
  }
}

export default all([
  takeLatest('@projectDashboard/INDEX_REQUEST', onIndex),
]);
